export default __webpack_public_path__ + "static/media/scalable.d043bbdf.png";